import { Window } from 'styles/Window'

const Loading = () => {

  return (
    (
    <Window>
      <p className="pagetitle">Loading...</p>
    </Window>
    )
  )
};

export default Loading;
